
  var emailEditData = function(email){
    fetch(JLAJAX.url+"email/data",{
      method:"POST",
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        email:email,
        island:JLAJAX.region
      })
    }).then(res=>res.json())
    .then(data=>{
      emailForm.reset();


      if(data.email){
        emailForm.edit(data);
      }



    });
  };
